import { createInstance } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enUS from '../translations/en-US.json'
import enCA from '../translations/en-CA.json'
import frCA from '../translations/fr-CA.json'

export const defaultNamespace = 'lithium'
export type LithiumNamespace = typeof defaultNamespace

const i18n = createInstance({
  fallbackLng: 'en_us',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en_us: { [defaultNamespace]: enUS },
    en_ca: { [defaultNamespace]: enCA },
    'en-CA': { [defaultNamespace]: enCA },
    fr: { [defaultNamespace]: frCA },
    fr_ca: { [defaultNamespace]: frCA },
    'fr-CA': { [defaultNamespace]: frCA },
  },
  detection: { order: ['querystring', 'path', 'navigator'] },
})

void i18n.use(LanguageDetector).init()

export default i18n
